// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3d266","bigColWidth":"Table_bigColWidth__1h5YL","biggerColWidth":"Table_biggerColWidth__EPZQK","row":"Table_row__1ClmL","col":"Table_col__7-6X5"};